const fallback = () => {
  console.error('Incorrect AvatarSelector data provider.');
  return Promise.reject();
};
const dp = {
  getAvatar: fallback,
  getName: fallback,
  resolveId: fallback,
  saveAvatar: fallback,
  deleteAvatar: fallback
};
export const getAvatarSelectorDataProvider = () => {
  // ensure to return same instance as this function could be called in
  // hooks frequently.
  return dp;
};
//# sourceMappingURL=AvatarSelectorDataProvider.js.map